if (process.env.REACT_APP_STRIPE_PK === undefined) {
  throw new Error('Missing env variables');
}

// eslint-disable-next-line import/prefer-default-export
export const stripePk = process.env.REACT_APP_STRIPE_PK;
